module.exports = __webpack_public_path__ + "img/verified-white-18dp.2019cadf.svg";